import { Reducer, AnyAction, Action } from 'redux';
import { ExternalUrlAdminListState } from './types-store';
import {
  ACTION, ClearList,
  RequestList, ReceiveList, FailList,
  RequestDeleteExternalUrl, ReceiveDeleteExternalUrl, FailDeleteExternalUrl
} from './action-types';

export const INITIAL_STATE: ExternalUrlAdminListState = {
  requestId: 0,
  fetching: false,
  requestedSearchModel: undefined,
  numberOfResults: undefined,
  listItems: undefined,
  deletingExternalUrls: []
};

const reducers: { [indexer: string]: Reducer<ExternalUrlAdminListState, Action> } = {

  [ACTION.CLEAR_LIST]: (state: ExternalUrlAdminListState, action: ClearList): ExternalUrlAdminListState => {
    return {
      ...state,
      requestId: action.requestId,
      fetching: false,
      requestedSearchModel: undefined,
      numberOfResults: undefined,
      listItems: undefined,
      deletingExternalUrls: []
    };
  },

  [ACTION.REQUEST_LIST]: (state: ExternalUrlAdminListState, action: RequestList): ExternalUrlAdminListState => {

    return {
      ...state,
      requestId: action.requestId,
      fetching: true,
      requestedSearchModel: action.model,
      ...(action.clearResults && {
        numberOfResults: undefined,
        listItems: undefined,
        deletingExternalUrls: []
      })
    };
  },

  [ACTION.RECEIVE_LIST]: (state: ExternalUrlAdminListState, action: ReceiveList): ExternalUrlAdminListState => {

    if (action.requestId !== state.requestId) {
      return state;
    }

    return {
      ...state,
      fetching: false,
      numberOfResults: action.numberOfResults,
      listItems: [
        ...(state.listItems || []),
        ...action.list
      ]
    };
  },

  [ACTION.FAIL_LIST]: (state: ExternalUrlAdminListState, action: FailList): ExternalUrlAdminListState => {

    if (action.requestId !== state.requestId) {
      return state;
    }

    return {
      ...state,
      fetching: false
    };
  },

  [ACTION.REQUEST_DELETE_EXTERNAL_URL]: (state: ExternalUrlAdminListState,
    action: RequestDeleteExternalUrl): ExternalUrlAdminListState => {

    return !state.deletingExternalUrls || !state.deletingExternalUrls.includes(action.id)
      ? {
        ...state,
        deletingExternalUrls: [
          ...(state.deletingExternalUrls || []),
          action.id
        ]
      }
      : state;
  },

  [ACTION.RECEIVE_DELETE_EXTERNAL_URL]: (state: ExternalUrlAdminListState,
    action: ReceiveDeleteExternalUrl): ExternalUrlAdminListState => {

    if (!state.deletingExternalUrls || !state.deletingExternalUrls.includes(action.id) || !state.listItems?.length) {
      return state;
    }

    const listItems = (state.listItems || []).filter(item => item.id !== action.id);

    return {
      ...state,
      listItems,
      numberOfResults: state.numberOfResults - (state.listItems.length - listItems.length),
      deletingExternalUrls: state.deletingExternalUrls.filter(id => id !== action.id)
    };
  },

  [ACTION.FAIL_DELETE_EXTERNAL_URL]: (state: ExternalUrlAdminListState,
    action: FailDeleteExternalUrl): ExternalUrlAdminListState => {

    return state.deletingExternalUrls && state.deletingExternalUrls.includes(action.id)
      ? {
        ...state,
        deletingExternalUrls: state.deletingExternalUrls.filter(id => id !== action.id)
      }
      : state;
  }
};

export const reducer: Reducer<ExternalUrlAdminListState> = (
  state: ExternalUrlAdminListState = INITIAL_STATE, action: AnyAction) => {
  const r = reducers[action.type];
  return (r && r(state, action)) || state;
};
